import { Injectable, Inject } from '@angular/core';
import { WizdomErrorHandler } from './app-error.handler';
import { BehaviorSubject, Observable } from 'rxjs';
import { AuthOIDCService } from '../auth/authOIDC.service';
// import { KeycloakService } from 'keycloak-angular';
import { WindowRef } from '../shared-service/windowRef.service';

declare var jquery: any;
declare var $: any;

@Injectable()
export class BaseService {

	private refresh: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	sResources: object | any = {};
	tempfResource: object | any = {};
	public routerParam: object | any = {};
	config: any;
	user: any = {};
	public isTrainingHistory: boolean = false;
	public isLrngClnder: boolean = false;
	notificationRoute: string | any
	public menu: { MenuItems: Array<any> } = { MenuItems: [] };
	public subMenu: Array<any> = [];
	public userProfileImage: string = ''
	public notificationCount: number = 0;
	public lastNotificationAlertCheck: number = 0;
	public announcementCount: number = 0;
	public lastAnnouncementAlertCheck: number = 0;
	public UnreadAnnouncementCount: number = 0;
	public UnreadNotificationCount: number = 0;
	public isResumeClicked: boolean = false;
	public objScormWindow: any;
	public isActiveNotification: boolean | any;
	public NotificationClass: string = "active";
	public AnnouncementClass: string = "";
	public HasOverView: boolean = false;
	public IsSpacedLearning: boolean = false;
	public SpacedLaunchId: number = 0;
	public SpacedNodeId: number = 0;
	public LastRunSync: string | any;
	public videoNotificationCount: number = 0;
	public showSkillRoleBased: boolean = false;

	public IsDeepLinkActive: boolean = false;
	public DeepLinkMenuItemKey: string = "";
	public DeepLinkSubmenuItemKey: string = "";
	public expression: string = '';

	public isDirectLogin: boolean = false;

	uploadControls: object | any = {
		generic: 'FileUpload/UploadJsonFile',
		profilePic: 'FileUpload/UploadProfileFile'
	};

	//
	public isVwLrng: boolean = false;
	public isShowAssignedFilter: boolean = false;
	public isLearningType: boolean = true;
	public profileRedirection: string = "";
	public isReadAndSign: boolean = false;
	public menuKey: string = '';
	public submenuKey: string = '';

	public paramsObject: Object = {};

	public BaseVariantType:VariantType=VariantType.Base;
	public LearnVariantType:VariantType=VariantType.Learn;
	public GrowVariantType:VariantType=VariantType.Grow;
	public ActVariantType:VariantType=VariantType.Act;
	//
	constructor(
		private wizdomErrorHandler: WizdomErrorHandler,
		private authOIDCServie: AuthOIDCService,
		private winRef: WindowRef
		// private keycloakService: KeycloakService
	) {
	}

	private mapedRoute: object | any = {
		/* Modules path */
		cnvrstn_mdl: '/learner/conversation/container',
		my_lrng_mdl: '/learner/learning/container',
		crs_ctlg_mdl: '/learner/course-catalog/container',
		srvy_mdl: 'learner/survey/container',
		vd_mdl: '/learner/video-library/container',
		ovrvw_mdl: '/learner/overview/container',
		extrnl_lrng_mdl: '/learner/external-learning/container',
		ldrbrd_mdl: '/learner/leaderboard/container',
		tsk_mdl: '/learner/taskList/container',
		compliance_mdl: '/learner/compliance/container',

		/* my-compliance */
		my_complnc: '/my-compliance/container',
		/* catalog */
		ctlg_dtl: '/catalog-detail',
		ctlg_ilt_cnvrstn: '/catalog-ilt-detail/catalog-conversation',
		ctlg_ilt_rtng: '/catalog-ilt-detail/catalog-rating',
		ctlg_ilt_morelikethis: '/catalog-ilt-detail/catalog-ilt-morelikethis',
		ctlg_ilt_dynamic: '/catalog-ilt-detail/catalog-ilt-dynamic',
		ctlg_ilt_dtl: '/catalog-ilt-detail',
		ctlg_crs_cnvrstn: '/catalog-detail/catalog-conversation',
		ctlg_crs_rtng: '/catalog-detail/catalog-rating',
		ctlg_crs_annncmnt: '/catalog-detail/catalog-announcement',
		ctlg_crs_dynamic: '/catalog-detail/catalog-dynamic',
		ctlg_crs_morelikethis: '/catalog-detail/catalog-crs-morelikethis',
		/* External Learning*/
		extrnl_dtls: '/external-details',

		/* Course- Relative to module path */
		crs_dtl: '/details/course-detail',
		ilt_dtl: '/details/ilt-detail',
		extrnl_dtl: '/details/external-details',

		/* Assessment- Relative to module path */
		asesmnt_opn: '/assessment/open-assessment',
		asesmnt_ply: '/assessment/play-assessment',
		asesmnt_cmplt: '/assessment/play-assessment/AssessmentComplete',
		asesmnt_rprt: '/assessment/play-assessment/AssessmentReport',
		asesmnt_attempt_rpt: '/assessment/open-report',
		ply_tf: '/assessment/play-assessment/TF',
		ply_fb: '/assessment/play-assessment/FB',
		ply_mc: '/assessment/play-assessment/MC',
		ply_mr: '/assessment/play-assessment/MR',
		ply_mf: '/assessment/play-assessment/MF',
		ply_os: '/assessment/play-assessment/OS',
		ply_ds: '/assessment/play-assessment/DS',

		wbnr_mdl: '/learner/webinar/container',

		/* Checklist- Relative to module path */
		checklist_open: '/checklist/open-checklist',
		checklict_play: '/checklist/play-checklist'
	}

	private dynamicPath: object | any = {};

	setCurrentModulePath(path: string) {
		this.dynamicPath['module'] = path;
	}

	getCurrentModulePath() {
		return this.dynamicPath['module'];
	}

	/* Returns full path with previous loaded module */
	getFullPath(nextPath: string) {
		return this.getCurrentModulePath() + this.getDirectPath(nextPath);
	}

	/* Used when there is no need of previous loaded module */
	getDirectPath(path: string) {
		return this.mapedRoute[path];
	}

	getFullComponentPath(moduleName: string, nextPath: string) {
		return this.mapedRoute[moduleName] + this.mapedRoute[nextPath];
	}

	/* Path new module inside another module */
	loadModulePath(path: string) {
		return this.mapedRoute[path];
	}



	/*For logging */
	log(type: any, msg: any) {
		if (type == 'info') {
			console.info(msg);
		} else if (type == 'warn') {
			console.warn(msg);
		} else if (type == 'error') {
			console.log(msg);
		} else {
			console.log(msg);
		}
	}

	loadConfig(appConfig: any) {
		this.config = appConfig;
	}


	loadStringResources(resources: any) {
		try {
			this.sResources = JSON.parse(resources);
			//this.mutateSresourceAndFresource();
		} catch (error) {
			this.sResources = resources;
		}
	}
	/* For error handling */
	errorHandler(error: any) {
		this.wizdomErrorHandler.handleError(error);
	}

	loadUserAccount(user: any) {
		try {
			this.user = JSON.parse(user);
		} catch (error) {
			this.user = user;
		}
	}

	getResource(key: any) {
		try {
			return this.sResources[key];
		}
		catch (error) {
			return key + ': Resource not found in DB.';
		}

	}

	getUserAttr(key: any) {
		return this.user[key];
	}

	setUserAttr(key: any, value: any) {
		this.user[key] = value;
	}

	deActivateMenus() {
		for (let i = 0; i < this.menu['MenuItems'].length; i++) {
			this.menu['MenuItems'][i]['isQuickLinkActive'] = false;
		}
	}

	deActivateSubMenus() {
		for (let i = 0; i < this.subMenu.length; i++) {
			this.subMenu[i]['isSubMenuActive'] = false;
		}
	}

	deActivateAllMenus() {
		this.deActivateMenus();
		this.deActivateSubMenus();
	}

	showPreloader() {

		var screenHeight = this.winRef.nativeWindow.document.body.clientHeight;

		var screenWidth = this.winRef.nativeWindow.document.body.clientWidth;
		$(".preloader-overlay").css("height", screenHeight + "px");

		$(".preloader-overlay").show();
		$(".preloader").show();

		$(this.winRef.nativeWindow.document).scrollTop(0);
	}
	hidePreloader() {
		$(".preloader-overlay").hide();
		$(".preloader").hide();

		$(this.winRef.nativeWindow.document).scrollTop(0);
	}

	logout() {
		sessionStorage.clear();
		if (this.isDirectLogin == false) {
			location.href = this.config.lmsBaseUrl + "Control/Controller.aspx?Action=forward/Lgt&ClearProxyLogin=true";
		}
		else {
			this.authOIDCServie.logout();
		}
	}

	loadScripts(dynamicScripts: string[]) {
		return new Promise((resolve, reject) => {
			try {
				for (let i = 0; i < dynamicScripts.length; i++) {
					const node = this.winRef.nativeWindow.document.createElement('script');
					node.src = dynamicScripts[i];
					node.type = 'text/javascript';
					node.async = false;
					node.charset = 'utf-8';
					this.winRef.nativeWindow.document.getElementsByTagName('head')[0].appendChild(node);
				}

				resolve(true);
			}
			catch (e) {
				reject(false)
			}
		});
	}

	RemoveScripts(dynamicScripts: string[], filetype: string) {
		return new Promise((resolve, reject) => {
			try {
				var targetelement = (filetype == "js") ? "script" : (filetype == "css") ? "link" : "none" //determine element type to create nodelist from
				var targetattr = (filetype == "js") ? "src" : (filetype == "css") ? "href" : "none" //determine corresponding attribute to test for
				var allsuspects = this.winRef.nativeWindow.document.getElementsByTagName(targetelement)
				for (let j = 0; j < dynamicScripts.length; j++) {
					for (var i = allsuspects.length; i >= 0; i--) { //search backwards within nodelist for matching elements to remove
						if (allsuspects[i] && allsuspects[i].getAttribute(targetattr) != null && allsuspects[i].getAttribute(targetattr)!.indexOf(dynamicScripts[j]) != -1)
							allsuspects[i].parentNode!.removeChild(allsuspects[i]) //remove element by calling parentNode.removeChild()
					}
				}
				resolve(true);
			}
			catch (e) {
				reject(false)
			}
		});
	}

	loadStyle(styleName: string) {
		let fileName = styleName.slice(styleName.lastIndexOf("/") + 1, styleName.length).replace('.', '-');
		if ($("#gcube-" + fileName).length) {
			console.log(" ALREADY LOADED", fileName);
		} else {
			var $head = $("head");
			var $headlinklast = $head.find("link[rel='stylesheet']:last");
			var linkElement = "<link id='gcube-" + fileName + "' rel='stylesheet' href='" + styleName + "' type='text/css' media='screen'>";
			if ($headlinklast.length) {
				$headlinklast.after(linkElement);
			} else {
				$head.append(linkElement);
			}
			console.log("LOADING", fileName);
		}
	}

	CloseSCORM() {
		if (this.objScormWindow != null) {
			if (this.objScormWindow.closed == false) {
				this.objScormWindow.close();
			}
		}
	}

	elScroll: any;

	setEl(el: any) {
		this.elScroll = el;
	}
	unsetEl() {
		this.elScroll = null;
	}

	bindScrollEvent() {
		this.elScroll.addEventListener('scroll', this.scroll, true);
	}

	unbindScrollEvent() {
		this.elScroll.removeEventListener('scroll', this.scroll, true);
	}

	scroll = (e: any): void => {
		if (e.target.scrollTop > 190) {
			this.addScrollClass();

		} else if (e.target.scrollTop == 0) {
			this.removeScrollClass();
		}
	}

	addScrollClass() {
		$("#nav-tabs-heading").addClass("nav-tab-fixed");
		$("#nav-tabs-heading").addClass("fadeIn");
		$(".ml-image-section").addClass("mlib-fixed");
		$(".ml-image-bottom").addClass("fadeIn");
	}
	removeScrollClass() {
		$("#nav-tabs-heading").removeClass("nav-tab-fixed");
		$("#nav-tabs-heading").removeClass("fadeIn");
		$(".ml-image-section").removeClass("mlib-fixed");
		$(".ml-image-bottom").removeClass("fadeIn");
	}
	//Funcation to load and activate Quick Link and it submenu after Global Search on behalf of item Module paramenter
	//itemModule=V => Video,M=> My learing,A=>Catalog,D=>Conversation,S=>Survey,H=>History
	activateMenuItem(itemModule: string) {
		let activatedMenu: string;
		let activatedQuickLink: string;
		switch (itemModule) {
			case "M":
				activatedMenu = "rbkey_MyLrnngLBL";
				activatedQuickLink = "rbkey_LrnLBL";
				break;

			case "A":
				activatedMenu = "rbkey_CtlgLBL";
				activatedQuickLink = "rbkey_LrnLBL";
				break;

			case "V":
				activatedMenu = "rbkey_VdLbrryLBL";
				activatedQuickLink = "rbkey_LrnLBL";
				break;

			case "H":
				activatedMenu = "rbkey_MyLrnngLBL";
				activatedQuickLink = "rbkey_LrnLBL";
				break;

			case "E":
				activatedMenu = "rbkey_ExtrnlLrnngLBL";
				activatedQuickLink = "rbkey_LrnLBL";
				break;

			case "D":
				activatedMenu = "rbkey_CnvrstnLBL";
				activatedQuickLink = "rbkey_CllbrtLBL";
				break;

			case "S":
				activatedMenu = "rbkey_SrvyLBL";
				activatedQuickLink = "rbkey_CllbrtLBL";
				break;

			case "G":
				activatedMenu = "rbkey_Ldr_BrdLBL";
				activatedQuickLink = "rbkey_CmptLBL";
				break;
			case "W":
				activatedMenu = "rbkey_WbmnrLBL";
				activatedQuickLink = "rbkey_CllbrtLBL";
				break;
		}
		let Menu = this.menu['MenuItems'].find((menu: any) => menu['Key'] == activatedQuickLink);
		if (Menu != undefined)
			this.loadSubMenu(Menu);
		let subMenu = this.subMenu.find((menu: any) => menu['Key'] == activatedMenu);
		if (subMenu != undefined)
			subMenu['isSubMenuActive'] = true;
		/* Recheck this case if overview was also added in search */
		if ($('.sub-header').is(":hidden")) {
			$('.sub-header').show();
		}
	}

	//Function for Selecting the Route Quick Link and its submenu after Global Search and Nav bar menu Selection
	loadSubMenu(item: any) {
		this.deActivateMenus();
		item.isQuickLinkActive = true;
		if (item.subMenuItems != null)
			this.subMenu = item.subMenuItems;
		this.deActivateSubMenus();
		this.menuKey = item.Key;
		if (this.subMenu.length > 0) {
			this.submenuKey = this.subMenu[0]['Key'];
		}
		switch (item.Key) {
			case "rbkey_OvrVwLBL": {
				this.winRef.nativeWindow.document.getElementById('MenuName')!.style.visibility = "hidden";
				break;
			}
			case "rbkey_LrnLBL": {
				this.winRef.nativeWindow.document.getElementById('MenuName')!.className = "coll-left-arrow switch learning-la"
				this.winRef.nativeWindow.document.getElementById('MenuName')!.style.visibility = "visible";
				this.winRef.nativeWindow.document.getElementById("headerMenuText")!.innerHTML = this.getResource('rbkey_MyLrnngLBL');
				break;
			}
			case "rbkey_CllbrtLBL": {
				this.winRef.nativeWindow.document.getElementById('MenuName')!.className = "coll-left-arrow conversation-la switch"
				this.winRef.nativeWindow.document.getElementById('MenuName')!.style.visibility = "visible";
				this.winRef.nativeWindow.document.getElementById("headerMenuText")!.innerHTML = this.getResource('rbkey_CnvrstnLBL');
				break;
			}
			case "rbkey_CmptLBL": {
				this.winRef.nativeWindow.document.getElementById('MenuName')!.className = "coll-left-arrow leaderboard-la switch"
				this.winRef.nativeWindow.document.getElementById('MenuName')!.style.visibility = "visible";
				this.winRef.nativeWindow.document.getElementById("headerMenuText")!.innerHTML = this.getResource('rbkey_Ldr_BrdLBL');
				break;
			}

		}
	}
	//ellipses
	textLimit(characters: any, limitChar: any) {
		let description = characters;
		let customDescription = description;
		if (parseInt(description.length) > parseInt(limitChar)) {
			customDescription = customDescription.substr(0, limitChar) + "...";
		}
		return customDescription;
	}
	DynamicObjSetter(cobject: object) {
		this.paramsObject = cobject;
		console.log(this.paramsObject);
		//return paramsObject;
	}

	public getUserAtibuteLoded(): Observable<boolean> {
		return this.refresh.asObservable();
	}

	public setUserAtibuteLoded(value: boolean): void {
		this.refresh.next(value);
	}
	isAlphaNumericWithRegex(expression: any) {
		var pattern = new RegExp("^[a-zA-Z0-9_-]*$");
		return pattern.test(expression);
	}

	public HasVariantAccess(variantType: VariantType): boolean {

		var type: number = this.getUserAttr("VariantType");
		var isVariantActive: boolean = this.getUserAttr("IsVariantActive");
		return variantType <= type && isVariantActive;
	}
}

export enum VariantType {
	Base = 1,
	Learn = 2,
	Grow = 4,
	Act = 8
}
